const STORAGE_KEY = 'hs_pending_request';
const MAX_AGE_MS = 48 * 60 * 60 * 1000;

/** Request ids are plain positive integers; anything else is rejected so it can never become a redirect target. */
export const parseRequestId = (value) => {
  const str = value == null ? '' : String(value).trim();
  return /^\d{1,10}$/.test(str) && Number(str) > 0 ? str : null;
};

export const savePendingRequestId = (requestId) => {
  const id = parseRequestId(requestId);
  if (!id) return;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ id, at: Date.now() }));
  } catch (e) {
    /* storage unavailable: the Requests page still lists the pending request */
  }
};

export const getPendingRequestId = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || Date.now() - Number(parsed.at) > MAX_AGE_MS) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return parseRequestId(parsed.id);
  } catch (e) {
    return null;
  }
};

export const clearPendingRequestId = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    /* ignore */
  }
};

export const requestsPathFor = (requestId) => {
  const id = parseRequestId(requestId);
  return id ? `/requests?request=${id}` : '/requests';
};
